var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable max-len */
import React from "react";
import styled from "styled-components";
import BaseSvgIcon from "./Base";
var MobileAppOnly = function (props) {
    return (React.createElement(BaseSvgIcon, __assign({ viewBox: "0 0 16 32" }, props),
        React.createElement("path", { d: "M13.6 2.978h-11.2c-1.36 0-2.4 1.040-2.4 2.4v24c0 1.36 1.040 2.4 2.4 2.4h11.2c1.36 0 2.4-1.040 2.4-2.4v-24c0-1.36-1.040-2.4-2.4-2.4zM1.6 9.378h12.8v15.2h-12.8v-15.2zM2.4 4.578h11.2c0.48 0 0.8 0.32 0.8 0.8v2.4h-12.8v-2.4c0-0.48 0.32-0.8 0.8-0.8zM13.6 30.178h-11.2c-0.48 0-0.8-0.32-0.8-0.8v-3.2h12.8v3.2c0 0.48-0.32 0.8-0.8 0.8zM7.76 27.538c-0.16 0.16-0.24 0.4-0.24 0.56 0 0.24 0.080 0.4 0.24 0.56s0.32 0.24 0.56 0.24c0.24 0 0.4-0.080 0.56-0.24s0.24-0.4 0.24-0.56-0.080-0.4-0.24-0.56c-0.32-0.32-0.88-0.32-1.12 0z" })));
};
export default styled(MobileAppOnly)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
